var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 23,
    viewBox: "0 0 21 23",
    width: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3856a7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m16.9684 22h-13.62746c-.3228.001-.64228-.0649-.93829-.1937-.296-.1287-.56202-.3175-.78133-.5543-.21931-.2369-.38713-.5167-.49278-.8217s-.146887-.6286-.12106-.9503l.88672-11.57334c.02352-.29297.15684-.56624.37315-.76523s.49966-.30902.79358-.30808h14.17577c.294-.00094.5774.10909.7938.30808.2163.19899.3495.47226.373.76523l.8867 11.57334c.0257.3208-.0151.6434-.1201.9476-.1049.3042-.2717.5834-.4898.8201-.218.2366-.4827.4257-.7773.5551-.2946.1295-.6128.1966-.9346.1972z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.48779 5.66666c0-1.23767.49162-2.42466 1.36683-3.29983.87522-.87517 2.06234-1.36683 3.30008-1.36683 1.2377 0 2.4247.49166 3.2999 1.36683s1.367 2.06216 1.367 3.29983"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cart.e7f720d1faa6c2ab30a260221b1dfd84.svg";